import { Query } from "@atgof-firebase/types";

export function notDeleted(q: Query) {
  return q.where("deleted", "==", false);
}
